import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const supportAPI = createApi({
    reducerPath: "supportAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllUserSupportsList: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/chat?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["support"],
        }),
        getSpecificUserSupportMessages: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/chat/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        replyToUserSupportMessage: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/chat/message",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["support"],
        }),
        closeUserSupportMessage: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/chat/close",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["support"],
        }),
    })
});

export const { 
    useGetAllUserSupportsListMutation,
    useGetSpecificUserSupportMessagesMutation,
    useReplyToUserSupportMessageMutation,
    useCloseUserSupportMessageMutation
} = supportAPI;

export default supportAPI;